enum FormFields {
  Building_Types = "buildingTypes",
  Transaction_Type = "transactionType",
  Stories = "stories",
  Project_Status = "projectStatus",
  Year_Built = "yearBuilt",
  Number_Of_Towers = "numberOfTowers",
  Number_Of_Units = "numberOfUnits",
  Construction_Start_Date = "constructionStartDate",
  Completion_Date = "completionDate",
  Lead_Architect = "leadArchitect",
  Landscape_Architect = "landscapeArchitect",
  Local_Architect = "localArchitect",
  Interior_Designer = "interiorDesigner",
  Overview = "overview",
  Project_Details = "projectDetails",
  Tax_Information = "taxInformation",
  Working_Hours = "workingHours",
}

const FormFieldsList = [
  FormFields.Overview,
  FormFields.Project_Details,
  FormFields.Lead_Architect,
  FormFields.Landscape_Architect,
  FormFields.Local_Architect,
  FormFields.Interior_Designer,
  FormFields.Building_Types,
  FormFields.Transaction_Type,
  FormFields.Stories,
  FormFields.Project_Status,
  FormFields.Year_Built,
  FormFields.Number_Of_Towers,
  FormFields.Number_Of_Units,
  FormFields.Construction_Start_Date,
  FormFields.Completion_Date,
  FormFields.Tax_Information,
];

export { FormFields, FormFieldsList };
